import { TONE_CLASSES } from "../assets/assetUtils";
export { Pill, Spinner, fmtD } from "../ppm/ppmUtils";

export const QUAL_TONE = { valid: TONE_CLASSES.ok, expiring: TONE_CLASSES.soon, expired: TONE_CLASSES.overdue, missing: TONE_CLASSES.none };
export const QUAL_LABEL = { valid: "Valid", expiring: "Expiring", expired: "Expired", missing: "Missing" };
export const PERMIT_TONE = { draft: TONE_CLASSES.none, issued: TONE_CLASSES.soon, active: TONE_CLASSES.ok, closed: TONE_CLASSES.none, cancelled: TONE_CLASSES.none };
export const LONE_TONE = { active: TONE_CLASSES.ok, overdue: TONE_CLASSES.soon, alarm: TONE_CLASSES.overdue, ended: TONE_CLASSES.none };

export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const toLocalInput = (iso) => (iso ? new Date(iso).toISOString().slice(0, 16) : "");

export function getPosition() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve({ latitude: null, longitude: null });
    navigator.geolocation.getCurrentPosition((p) => resolve({ latitude: p.coords.latitude, longitude: p.coords.longitude }), () => resolve({ latitude: null, longitude: null }), { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 });
  });
}

export function Tile({ label, value, tone = "", testid, onClick, active, hint }) {
  const Cmp = onClick ? "button" : "div";
  return (
    <Cmp onClick={onClick} className={`rounded-lg border bg-card p-3 text-left ${onClick ? "hover:border-primary/50 transition-colors" : ""} ${active ? "border-primary" : "border-border"}`} data-testid={testid}>
      <p className="text-[11px] text-muted-foreground">{label}</p>
      <p className={`text-xl font-bold font-[Chivo] ${tone}`}>{value ?? "—"}</p>
      {hint && <p className="text-[10px] text-muted-foreground">{hint}</p>}
    </Cmp>
  );
}
